<!-- Ремонт -->
<template>
  <li
    v-if="canSeePage('repairs')"
    class="nav-item"
    role="button"
    tabindex="0"
    @click="navigate($event, 'Repairs')"
    @mouseup="handleMiddleClick($event, 'Repairs')"
    @contextmenu.prevent.stop="showContextMenu($event, 'Repairs')"
    :class="{ active: activeItem === 'repairs' }"
    :title="collapsed ? 'Ремонт' : ''"
  >
    <div class="link-icon_box">
      <AppIcon name="wrench" :size="24" stroke="#ffffff" />
    </div>
    <AppSidebarItemLabel
      label="Ремонт"
      :collapsed="collapsed"
      :show-new-badge="showNewBadge"
    />
  </li>
</template>

<script>
import AppSidebarItemLabel from "@/components/AppSidebar/ItemLabel.vue";
import AppIcon from "@/components/Icon/AppIcon.vue";
import { sidebarItemProps } from "@/composables/useSidebarItem";

export default {
  name: "RepairsItem",

  components: {
    AppSidebarItemLabel,
    AppIcon,
  },

  props: sidebarItemProps,

  emits: ["navigate", "middle-click", "context-menu"],

  methods: {
    navigate(event, routeName) {
      this.$emit("navigate", event, routeName);
    },

    handleMiddleClick(event, routeName) {
      this.$emit("middle-click", event, routeName);
    },

    showContextMenu(event, routeName) {
      this.$emit("context-menu", event, routeName);
    },
  },
};
</script>
